import styled from 'styled-components';

export const TopbarContainer = styled.div`
  nav {
    display: flex;
    width: 100%;
    position: relative;
    height: 50px;
    top: 0;
    z-index: 8;
  }

  nav .container {
    position: relative;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    top: 0;
    height: 50px;
    width: 100%;
    padding: 0 1rem;
  }

  nav .container .brand {
    font-size: 2rem;
    height: auto;
    color: var(--color-primary);
  }

  nav .profile-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4rem;
    padding-right: 2rem;
  }

  nav .profile-area .theme-btn {
    display: flex;
    background: var(--color-light);
    width: 5rem;
    height: 2rem;
    border-radius: var(--border-radius-2);
    cursor: pointer;
  }

  nav .profile-area .theme-btn span {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
  }

  nav .profile-area .theme-btn .active {
    background: var(--color-dark);
    border-radius: var(--border-radius-2);
    color: var(--color-white);
  }

  nav .profile-area .profile {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  nav .profile-area .profile-photo {
    display: block;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    overflow: hidden;
    object-fit: cover;
  }

  nav .profile-area button#menu-btn {
    display: none;
  }

  nav .profile-area .logout {
    cursor: pointer;
    display: flex;
    align-items: center;
    background: none;
  }

  @media screen and (max-width: 1024px) {
    nav .container .brand {
      font-size: 1.7rem;
    }

    nav .profile-area {
      gap: 2rem;
      margin: 0 5px;
      padding-right: 0;
    }

    nav .profile-area button#menu-btn {
      display: flex;
      background: transparent;
      color: var(--color-dark);
    }
  }
`;
